import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { useSemester } from './SemesterContext';
import DepartmentService from './services/DepartmentService';
import { DEPARTMENTS } from './constants/departments';

const DepartmentsContext = createContext();

export const DepartmentsProvider = ({ children }) => {
  const { currentSemester } = useSemester();
  const [departments, setDepartments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchDepartments = useCallback(async () => {
    setLoading(true);
    try {
      const semesterId = currentSemester?._id ? String(currentSemester._id) : undefined;
      const data = await DepartmentService.getDepartments({ semester: semesterId });
      setDepartments(Array.isArray(data) && data.length > 0 ? data : DEPARTMENTS);
      setError(null);
    } catch (err) {
      console.error('Failed to fetch departments:', err);
      setError(err);
      setDepartments(DEPARTMENTS);
    } finally {
      setLoading(false);
    }
  }, [currentSemester?._id]);

  useEffect(() => {
    fetchDepartments();
  }, [fetchDepartments]);

  const value = useMemo(
    () => ({
      departments,
      loading,
      error,
      refreshDepartments: fetchDepartments,
    }),
    [departments, loading, error, fetchDepartments]
  );

  return (
    <DepartmentsContext.Provider value={value}>
      {children}
    </DepartmentsContext.Provider>
  );
};

export const useDepartments = () => {
  const context = useContext(DepartmentsContext);
  if (!context) {
    throw new Error('useDepartments must be used within a DepartmentsProvider');
  }
  return context;
};
